/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import { router } from "../../router";

import {
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_ERROR,
  AUTH_LOGOUT,
  CHECK_SUCCESS,
  SAVE_USER_LOGIN_DATA,
  AUTH_CHECK
} from "../../store/actions/auth";
import { login, logout, authCheck } from "../../api/auth";

const state = {
  status: localStorage.getItem("status") || "",
  userId: localStorage.getItem("userId") || "",
  userRole: localStorage.getItem("userRole") || "",
  userGroup: localStorage.getItem("userGroup") || "",
  userManageKeywords: localStorage.getItem("userManageKeywords") ? localStorage.getItem("userManageKeywords") === "true" : false,
  userName: localStorage.getItem("userName") || "",
  userLogin: localStorage.getItem("login") || "",
  userPassword: localStorage.getItem("password") || "",
  userCity: localStorage.getItem("userCity") || "",
  userMaxThreads: localStorage.getItem("userMaxThreads") || "0",
};

const getters = {
  isAuthenticated: state => state.status === "success",
  userId: state => state.userId,
  userRole: state => state.userRole,
  userGroup: state => state.userGroup,
  userName: state => state.userName,
  userManageKeywords: state => state.userManageKeywords,
  isAdmin: state => state.userRole === "admin",
  userCity: state => state.userCity,
  userCityMapCoords: state => {
    if (state.userCity) {
      const coords = state.userCity.split(',');
      if (coords.length === 2) {
        return [parseFloat(coords[0].trim()), parseFloat(coords[1].trim())];
      }
    }

    return [59.939095, 30.315868];
  },
  userMaxThreads: state => state.userMaxThreads,
  userLoginData: state => {
    if (state.userLogin) {
      return {
        login: state.userLogin,
        password: state.userPassword
      }
    } else {
      return null;
    }
  }
};

const actions = {
  [SAVE_USER_LOGIN_DATA]: ({commit}, userLoginData) => {
    commit(SAVE_USER_LOGIN_DATA, userLoginData);
  },
  [AUTH_REQUEST]: ({ commit }, loginParams) =>
    new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      login(loginParams)
        .then(resp => {
          //commit(AUTH_SUCCESS, resp.data);
          commit(AUTH_CHECK)
          //console.log('user', resp.data);
          localStorage.setItem("access", resp.data.token);
          resolve(resp);
          window.location.href = '/'
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          reject(err);
        });
    }),
  /**
   * @param commit
   * @param resetVal
   * @returns {Promise}
   */
  [AUTH_LOGOUT]: ({ commit }) =>
    new Promise(resolve => {
      commit(AUTH_REQUEST);
      logout()
        .then(() => {
          localStorage.clear();
          commit(AUTH_LOGOUT);
          router.push("/login");
          resolve();
        })
        .catch(() => {
          localStorage.clear();
          commit(AUTH_LOGOUT);
          router.push("/login");
          resolve();
        });
      }),
    [AUTH_CHECK]: ({ commit }) =>
      new Promise(resolve => {
        commit(AUTH_REQUEST);
        authCheck()
          .then((resp) => {
            commit(AUTH_SUCCESS, resp.data);
            console.log('user', resp.data);
            resolve(resp);
          })  
    })
};

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = "loading";
    localStorage.setItem("status", "loading");
  },
  [SAVE_USER_LOGIN_DATA]: (state, payload) => {
    localStorage.setItem("login", payload.login);
    localStorage.setItem("password", payload.password);
  },
  [AUTH_SUCCESS]: (state, payload) => {
    state.status = "success";
    state.userId = payload.uid;
    state.userRole = payload.role;
    state.userGroup = payload.group;
    state.userName = payload.username;
    state.userManageKeywords = payload.manage_keywords;
    state.userCity = payload.map_center;
    state.userMaxThreads = payload.max_threads;

    localStorage.setItem("status", "success");
    localStorage.setItem("userId", payload.uid);
    localStorage.setItem("userRole", payload.role);
    localStorage.setItem("userGroup", payload.group);
    localStorage.setItem("userName", payload.username);
    localStorage.setItem("userManageKeywords", payload.manage_keywords);
    localStorage.setItem("userCity", payload.map_center);
    localStorage.setItem("userMaxThreads", payload.max_threads);
  },
  [AUTH_ERROR]: state => {
    state.status = "error";
    localStorage.clear();
  },
  [AUTH_LOGOUT]: state => {
    state.status = "logout";
    localStorage.clear();
  },
  [CHECK_SUCCESS]: state => {
    state.status = "success";
    localStorage.removeItem("status");
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
